"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NaNAbilityHandler = exports.NaNActorAbilityFactory = exports.NaNAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const EffectType_1 = require("../../core/effects/EffectType");
const core_1 = require("../../core/effects/core");
const ts_essentials_1 = require("ts-essentials");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const TimeInterval_1 = require("../../core/vfx/TimeInterval");
const Duration_1 = require("../../core/Duration");
const enums_1 = require("../../core/enums");
class NaNAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.NaN;
        this.__typeName = "NaN";
    }
}
exports.NaNAbilityArgs = NaNAbilityArgs;
let NaNActorAbilityFactory = class NaNActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("NaN", "OneAllies", 0);
    }
};
NaNActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("NaN")
], NaNActorAbilityFactory);
exports.NaNActorAbilityFactory = NaNActorAbilityFactory;
let NaNAbilityHandler = class NaNAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        const wp = container.getEffectsOfType(targetId, EffectType_1.EffectType.Withering)
            .map(eid => container.getEffect(eid))
            .reduce((sum, next) => sum + next.args.power, 0);
        (0, ts_essentials_1.assert)(wp >= 50, `NOT_ENOUGH_WITHER_POWER`);
        const count = Math.floor(wp / 50);
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                sequence = sequence.pushSequence("sequential");
                for (let i = 0; i < count; i++) {
                    container.applyBuff({
                        sequence: sequence
                            .push(new core_2.DelayVfxStepArgs(new TimeInterval_1.MillisecondVfxTimeInterval(i * 25)))
                            .pushSequence("parallel"),
                        creatorId: ability.invokerId,
                        targetId,
                        duration: Duration_1.Duration.Turns(1),
                        effect: new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.ExtraActions, 1),
                        onApplied: sequence => sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet"), "MagicOrbitingShield", false))
                    });
                }
            }
        });
    }
};
NaNAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.NaN)
], NaNAbilityHandler);
exports.NaNAbilityHandler = NaNAbilityHandler;
